import { FunctionComponent } from "react";
import BasicCard from "@components/cards/BasicCard";
import BasicButton from "@components/buttons/BasicButton";
import { useTranslation } from "react-i18next";

interface AnswerCardProps {
  text?: string;
  className?: string;
}

const AnswerCard: FunctionComponent<AnswerCardProps> = ({
  text,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <BasicCard className={`card-answer ${className}`}>
      <div className="d-flex align-items-center justify-content-center">
        <div className="answer-img">
          <img src="/img/answer.png" alt="Réponse" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <div className="answer-text">{text ?? t("answers.label")}</div>
          <BasicButton
            text="En savoir plus"
            variant="secondary"
            role="link"
            onClick={() => {
              window.open(t("answers.url"), "_blank");
            }}
            className="mt-3"
          />
        </div>
      </div>
    </BasicCard>
  );
};

export default AnswerCard;
